import { render, staticRenderFns } from "./subContent.vue?vue&type=template&id=864d32bc&scoped=true"
import script from "./subContent.vue?vue&type=script&lang=js"
export * from "./subContent.vue?vue&type=script&lang=js"
import style0 from "./subContent.vue?vue&type=style&index=0&id=864d32bc&prod&lang=scss&scoped=true"
import style1 from "./subContent.vue?vue&type=style&index=1&id=864d32bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d32bc",
  null
  
)

export default component.exports